import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setPluginList } from 'Workspace/Plugins/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const workspacePluginList = yield call(connection.fetch.bind(connection), constants.RTM_WORKSPACE_PLUGIN_LIST);
  if (workspacePluginList.type === constants.RTM_WORKSPACE_PLUGIN_LIST_OK) {
    const plugins = workspacePluginList.response.plugins;
    yield put(setPluginList(plugins));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePluginListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_LIST, catchErrors, sendRequest, connection);
}
